module.exports = __webpack_public_path__ + "img/5.07.thmb.xs.e6b40561.jpg";